import { Dialog, DataService, SharedModule } from "@bb-vendure/admin-ui/core";
import {
  concat,
  Observable,
  of,
  Subject,
  debounceTime,
  distinctUntilChanged,
  tap,
  switchMap,
  catchError,
} from "rxjs";
import { Component, OnInit } from "@angular/core";
import {
  Zone,
  LogicalOperator,
  SortOrder,
  GetZonesDocument,
} from "src/generated-gql/graphql";

@Component({
  selector: "select-zone",
  standalone: true,
  imports: [SharedModule],
  templateUrl: "./select.component.html",
})
export default class SelectZoneModalComponent
  implements OnInit, Dialog<Zone | null>
{
  ngOnInit(): void {
    this.countries$ = concat(
      this.dataService
        .query(GetZonesDocument, {
          options: {
            take: 5,
            sort: {
              createdAt: SortOrder.Desc,
            },
          },
        })
        .single$.pipe(
          switchMap((data) => {
            return of(data.zones.items);
          })
        ),
      this.input$.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        tap(() => (this.isLoading = true)),
        switchMap((term) =>
          this.dataService
            .query(GetZonesDocument, {
              options: {
                filter: {
                  name: {
                    contains: term,
                  },
                },
                filterOperator: LogicalOperator.Or,
              },
            })
            .mapStream(({ zones }) => zones.items)
            .pipe(
              catchError(() => of([])),
              tap(() => (this.isLoading = false))
            )
        )
      )
    ) as Observable<Zone[]>;
  }

  trackByFn(item: Zone) {
    return item.id;
  }
  cancel() {
    this.resolveWith(null);
  }

  select() {
    this.resolveWith(this.selectedCountry!);
  }

  input$ = new Subject<string>();
  isLoading = false;
  countries$: Observable<Zone[]>;
  selectedCountry: Zone | null = null;

  constructor(private dataService: DataService) {}
  resolveWith: (result?: Zone | null) => void;
}
